var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8Disabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 150,
    viewBox: "0 0 100 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "innactive_9",
    transform: "translate(-496 -610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2140",
    "data-name": "Group 2140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1119",
    "data-name": "Rectangle 1119",
    transform: "translate(496 610)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 150,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 149,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2785",
    "data-name": "Group 2785",
    transform: "translate(0 -60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1672",
    "data-name": "Rectangle 1672",
    transform: "translate(504 675)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1699",
    "data-name": "Rectangle 1699",
    transform: "translate(504 711)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1702",
    "data-name": "Rectangle 1702",
    transform: "translate(504 747)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1695",
    "data-name": "Rectangle 1695",
    transform: "translate(534 675)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1698",
    "data-name": "Rectangle 1698",
    transform: "translate(534 711)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1701",
    "data-name": "Rectangle 1701",
    transform: "translate(534 747)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1696",
    "data-name": "Rectangle 1696",
    transform: "translate(564 675)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1697",
    "data-name": "Rectangle 1697",
    transform: "translate(564 711)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1700",
    "data-name": "Rectangle 1700",
    transform: "translate(564 747)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703",
    "data-name": "Rectangle 1703",
    width: 25,
    height: 1,
    transform: "translate(504 702)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710",
    "data-name": "Rectangle 1710",
    width: 25,
    height: 1,
    transform: "translate(504 738)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716",
    "data-name": "Rectangle 1716",
    width: 25,
    height: 1,
    transform: "translate(504 774)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1706",
    "data-name": "Rectangle 1706",
    width: 25,
    height: 1,
    transform: "translate(534 702)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711",
    "data-name": "Rectangle 1711",
    width: 25,
    height: 1,
    transform: "translate(534 738)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717",
    "data-name": "Rectangle 1717",
    width: 25,
    height: 1,
    transform: "translate(534 774)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708",
    "data-name": "Rectangle 1708",
    width: 25,
    height: 1,
    transform: "translate(564 702)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1714",
    "data-name": "Rectangle 1714",
    width: 25,
    height: 1,
    transform: "translate(564 738)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1719",
    "data-name": "Rectangle 1719",
    width: 25,
    height: 1,
    transform: "translate(564 774)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1704",
    "data-name": "Rectangle 1704",
    width: 25,
    height: 1,
    transform: "translate(504 705)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709",
    "data-name": "Rectangle 1709",
    width: 25,
    height: 1,
    transform: "translate(504 741)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715",
    "data-name": "Rectangle 1715",
    width: 25,
    height: 1,
    transform: "translate(504 777)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1705",
    "data-name": "Rectangle 1705",
    width: 25,
    height: 1,
    transform: "translate(534 705)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712",
    "data-name": "Rectangle 1712",
    width: 25,
    height: 1,
    transform: "translate(534 741)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1718",
    "data-name": "Rectangle 1718",
    width: 25,
    height: 1,
    transform: "translate(534 777)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1707",
    "data-name": "Rectangle 1707",
    width: 25,
    height: 1,
    transform: "translate(564 705)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713",
    "data-name": "Rectangle 1713",
    width: 25,
    height: 1,
    transform: "translate(564 741)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720",
    "data-name": "Rectangle 1720",
    width: 25,
    height: 1,
    transform: "translate(564 777)",
    fill: "#cfcfcf"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_9",
    "data-name": 9,
    transform: "translate(539 750)",
    fill: "#cfcfcf",
    fontSize: 24,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8Disabled);
export default __webpack_public_path__ + "static/media/8-disabled.003d0d75.svg";
export { ForwardRef as ReactComponent };